<template>
	<v-checkbox
		:label="label"
		v-model="checked"
		:value="value"
		@change="onChange($event)"
	/>
</template>

<script>
export default {
	props: {
		label: String,
		value: Boolean,
	},
	data() {
		return {
			checked: false,
		}
	},
	created() {
		this.checked = this.value || false
	},
	watch: {
		value() {
			this.checked = this.value
		},
	},
	methods: {
		onChange(event) {
			this.$emit('input', event || false)
		},
	},
}
</script>
